import axios from "axios";
import store from "@/store";
import { setupResponseInterceptor } from './responseInterceptor';

const discountCodesClient = axios.create({
  baseURL: process.env.VUE_APP_DISCOUNT_CODES_URL,
  withCredentials: true,
});

discountCodesClient.interceptors.request.use((config) => {
  config.headers.lang = store.getters["getLang"];
  return config;
});

setupResponseInterceptor(discountCodesClient);

export default discountCodesClient;